import { getLocale } from '@utils/index.js';

interface TimezoneParams {
  siteMeta:
    | { GPSLat?: number | string | null; GPSLong?: number | string | null }
    | null
    | undefined;
  timeMode: string;
}

export const getTimezoneOffset = ({
  siteMeta,
  timeMode,
}: TimezoneParams): number => {
  if (!siteMeta) {
    return 0;
  }

  const { GPSLat, GPSLong } = siteMeta;

  return getLocale({
    timeMode,
    lat: GPSLat,
    long: GPSLong,
    utcOffset: true,
  });
};
